"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reportcard_html_1 = __importDefault(require("./reportcard.html"));
function dcReportcard() {
    return {
        restrict: "E",
        scope: {
            reportcard: "=",
        },
        template: reportcard_html_1.default,
        link: function (scope, element, attrs) { },
        controller: "dcReportcardController",
        controllerAs: "vm",
        bindToController: true,
    };
}
dcReportcard.$inject = [];
exports.default = dcReportcard;
